module.exports = __webpack_public_path__ + "img/img5-4.d2f181a4.png";